<template>
    <div>
        <bread-crumb></bread-crumb>
        <div class="content-sensitive">
            <manFormList
            :select="select"
            :selectList="selectList"
            :isBtn="isBtn"
            @empty="empty"
            @getChangeValue="getChangeValue"
           ></manFormList>
        </div>
        <div class="base-table">
            <div class="content-sensitive-btn">
                <el-row class="import-btn" type="flex" justify="start">
                    <!-- 导出类目Export -->
                    <el-button size="small" type="text" :disabled="isButton" @click="downLoadFiles">下载导入模版
                    </el-button>
                    <!-- 上传敏感词 -->
                    <el-upload
                        style="margin: 0 10px"
                        action="/api"
                        class="upload-demo"
                        :auto-upload="true"
                        :http-request="httpRequest"
                        :before-upload="checkFile"
                        :disabled="flag || requesting"
                        accept=".doc,.docx,.xls,.xlsx"
                        :show-file-list="false">
                        <el-button size="small" type="primary" :disabled="flag || requesting">上传敏感词</el-button>
                    </el-upload>
                    <!-- 下载敏感词 -->
                    <el-button size="small" type="primary" :loading="uploadShow" @click="getExportSensitive">{{uploadShow ? '下载中' : '下载敏感词'}}
                    </el-button>
                    <el-button size="small" type="danger" v-if="isImportErrorShow" @click="jumpToFailUrl('import')">导入敏感词失败
                    </el-button>
                    <el-button size="small" type="danger" v-if="isExportErrorShow" @click="jumpToFailUrl('export')">导出敏感词失败
                    </el-button>
                </el-row>
            </div>
            <div class="base-table-table"> 
                <el-table
                :data="tableList"
                style="width: 100%">
                    <el-table-column
                        prop="word"
                        label="名称">
                    </el-table-column>
                    <el-table-column
                        prop="typeDesc"
                        label="分类">
                        <!-- <template slot-scope="scope">
                            <div v-html="scope.row.typeDesc">{{scope.row.typeDesc}}</div>
                        </template> -->
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        prop="createUser">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <div>
                                <el-button type="text" size="small" @click="deleteManCommentInfo(scope.row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>

                    
                </el-table>
            </div>
        </div>
        <!-- 分页 -->
         <pagination
            @sizePageChange="paginationChangeProduct"
            :paginationDatas="paginationDataProduct"
        ></pagination>
    </div>
</template>

<script>
    import utils from "../../../../utils"
    // import baseTable from '../../../../components/baseTable';
    import manFormList from '../../components/manFormList';
    import breadCrumb from "../../../../components/breadCrumb";
    import modal from '@/components/modal';
    import pagination from '../../../../components/pagination';
    import {getOutArticleCategory, uploadCategoryExl, fileChange} from "../../components/importExportCommon";
    import {
        manPageContentSensitiveWo,
        manImportContentSensitive,
        manUpdateContentSensitive,
        queryDictionaries,
        manExportContentSensitive,
        // cancelCommentInfoTopStatus
    } from '@/api/sensitive';
    import {
        importExportLog,
    } from "@/api/questionsLibrary";
    export default {
        data(){
            return {
                // 弹框
                dialogTitle:'删除',
                isShowBtn:[true,true],
                btnText:['取消','删除'],
                failImportUrl: '', // 导入失败链接
                failExportUrl: '', // 导出失败链接
                uploadShow: false,
                isImportErrorShow: false,
                isExportErrorShow: false,
                dialogText:'是否确认删除',
                dialogType:'',
                isButton: false,
                ruleForm:{
                    desc:''
                },
                // form 表单绑定参数
                selectList: {
                    wordLike: "", // 敏感词
                    typeCode: "", // 分类
                },
                isBtn:1,
                select:[
                    {
                        prop:'wordLike',
                        type:'input',
                        placeholder:'请输入敏感词',
                        // List: [],
                    },
                    {
                        prop:'typeCode',
                        type:'select',
                        placeholder:'请选择分类',
                        List: [],
                    },
                ],
                // table表格
                tableList: [],
                paginationDataProduct: {
                    total: 0,
                    currentPage: 1,
                    pageSize: 10
                },
                rules:{
                    desc: [
                        { required: true, message: '请填写驳回理由', trigger: 'blur' }
                    ]
                },
                tableListValue:{},
                options: [],
            }
        },
        components:{
            // baseTable,
            manFormList,
            breadCrumb,
            pagination
        },
        created(){
            this.pageManCommentInfos();
            this.initData();
        },
        methods:{
            // 类型查询
            initData () {
                queryDictionaries({
                    typeList: [24]
                }).then((res) => {
                    this.select = this.select.map((item) =>
                        item.prop === 'typeCode' ?
                        { ...item, List: res.map((dic) => ({
                            label: dic.desc,
                            value: dic.code,
                        })) }
                        : item);
                })
            },
            // 查询
            getChangeValue(){
                this.paginationDataProduct.currentPage = 1
                this.paginationDataProduct.pageSize = 10
                this.pageManCommentInfos()
            },
            // 重置
            empty(){
                this.paginationDataProduct.currentPage = 1
                this.paginationDataProduct.pageSize = 10
                Object.keys(this.selectList).map(item => {
                    this.selectList[item] = ''
                })
                this.pageManCommentInfos()
            },
            // 分页
            paginationChangeProduct(val) {
                this.paginationDataProduct=val
                this.pageManCommentInfos()
            },
            // 弹框操作按钮
            ClickHandler(val){
                if(val === 'one'){
                    this.isShowDialog = false
                }else{
                    switch (this.dialogType) {
                        // 通过
                        case 'pass':
                            this.passCommentInfo()
                            return;
                        // 驳回
                        case 'reject':
                            this.rejectCommentInfo()
                            return;
                        // 置顶
                        case 'stick':
                            this.addCommentInfoTopStatus()
                            return;
                        // 取消置顶
                        case 'cancelStick':
                            this.cancelCommentInfoTopStatus()
                            return;
                        // 删除
                        case 'delete':
                            this.deleteManCommentInfo()
                            return;
                        default:
                            this.isShowDialog = false
                            return;
                    }
                }
            },
            // 分页请求
            pageManCommentInfos(){
                // console.log(this.selectList.auditStatus,'----------');
                let data = {
                    tenantId: Number(this.$commonJs.getTenantId()),
                    wordLike: this.selectList.wordLike, // 敏感模糊匹配
                    typeCode: this.selectList.typeCode ? this.selectList.typeCode : "",    // 分类code
                    pageNo: this.paginationDataProduct.currentPage,
                    pageSize: this.paginationDataProduct.pageSize
                }
                manPageContentSensitiveWo(data)
                .then(res => {
                    // console.log(res.data);
                    console.log(res);
                    this.tableList.splice(0,this.tableList.length)
                    res.data.map(item => {
                        this.tableList.push(item)
                    })
                    this.paginationDataProduct.total =  res.totalCount
                })
            },
            //轮询查询
            loopImportExportLog(type) {
                this.timer = setInterval(()=>{
                    this.getImportExportLog(type)
                }, 3000);
            },
            //轮询查看类目导入导出方法
            getImportExportLog(type) {
                let params = {
                    importExportCode:3,
                    importExportType:type
                }
                importExportLog(params).then(res => {
                    console.log(res.outFileUrl)
                    if (res.importExportStatus == 3) {
                    this.uploadShow = false
                    
                    if(res.importExportType == 1){
                        this.$message.success(`导入成功`);
                        this.paginationDataProduct.currentPage = 1;
                        this.pageManCommentInfos();
                    }else if(res.importExportType == 2){
                        this.$message.success(`导出成功`);
                        window.location.href = res.outFileUrl;
                    }
                    if(this.timer){
                        clearInterval(this.timer);
                        this.timer = null
                        }
                    } else if(res.importExportStatus == 4){
                        this.uploadShow = false
                        if(res.importExportType == 1){
                            this.isImportErrorShow = true
                            this.$message.error(`导入失败`);
                            this.failImportUrl = res.failFileUrl
                        }else if(res.importExportType == 2){
                            this.isExportErrorShow = true
                            this.failExportUrl = res.failFileUrl
                            this.$message.error(`导出失败`);
                        }
                        if(this.timer){
                            clearInterval(this.timer);
                            this.timer = null
                        }
                    }
                }).catch(err => {
                    console.log('获取列表数据出错')
                    console.log(err);
                });
            },
            // 删除
            deleteManCommentInfo(row){
                this.$confirm('确认删除此敏感词?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        tenantId: this.$commonJs.getTenantId(),
                        wordId: row.wordId,
                        yn: 0,
                    }
                    manUpdateContentSensitive(data).then((res) => {
                        console.log(res);
                        if (res) {
                            this.$message.success('删除成功');
                            this.pageManCommentInfos()
                        } else {
                            this.$message.error('删除失败')
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            checkFile(file) {
                const isWord = /(office|application)(.*)(document|sheet|msword|excel)/.test(file.type)
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isWord) {
                    this.$message.error('上传文件只能是word、excel格式！');
                }
                if (!isLt1M) {
                    this.$message.error('上传文件大小不能超过 1MB!');
                }
                let data = window.URL.createObjectURL(new Blob([file]))
                this.fileName = file.name;
                this.file = data;
                return isWord && isLt1M;
            },
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    let reader = new FileReader();
                    let fileResult = "";
                    reader.readAsDataURL(file);
                    //开始转
                    reader.onload = function() {
                    fileResult = reader.result;
                    };
                    //转 失败
                    reader.onerror = function(error) {
                    reject(error);
                    };
                    //转 结束  咱就 resolve 出去
                    reader.onloadend = function() {
                    resolve(fileResult);
                    };
                });
            },
            httpRequest(request){
                if(this.flag || this.requesting) return;
                this.flag = true;
                this.getBase64(request.file).then(resBase64 => {
                    this.uploadStatus='pending';
                    this.fileBase64 = resBase64.split(',')[1];// 直接拿到base64信息
                    this.uploadFile(this.fileBase64);
                })
            },
            onChange() {
                this.formLabelAlign.title = '';
                this.formLabelAlign.desc = '';
            },
            // 上传文件
            uploadFile(fileBase64){
                manImportContentSensitive({
                    tenantId: this.$commonJs.getTenantId(),
                    fileName: this.fileName,
                    fileBase64: fileBase64,
                    importExportCode: 3,
                })
                .then(res => {
                    if(res) {
                        this.fileName = res.fileName
                        this.uploadStatus = 'resolve';
                        // this.$message.success('文件上传成功');
                        this.flag=false;
                        this.loopImportExportLog(1)
                    }
                })
                .catch((res) => {
                    this.uploadStatus = "reject";
                    this.flag=false;
                    this.uploadError = res.msg;
                    this.$message.error('文件上传失败');
                });
            },
            // 下载模版
            downLoadFiles() {
                this.isButton = true
                window.location.href = '//storage.360buyimg.com/cms-bucket/importExcel/3/ImportTemplate/ImportTemplate_%E5%AF%BC%E5%85%A5%E5%86%85%E5%AE%B9%E6%95%8F%E6%84%9F%E8%AF%8D%E6%A8%A1%E6%9D%BF.xlsx?Expires=3817977206&AccessKey=Jd9HhkNEAtwojp2B&Signature=2yzAMF0%2BNqgpNmvu5cQJygXVWWQ%3D';
                setTimeout(() => {
                this.isButton = false
                }, 3000)
            },
            // 导出敏感词
            getExportSensitive() {
                getOutArticleCategory(this, 3)
            },
            exFormData(){
                let parameter = {
                    tenantId: +this.$commonJs.getTenantId(),
                    typeCode: this.selectList.typeCode,
                    wordLike: this.selectList.wordLike,
                };
                return parameter;
            },
            // 导入失败文件 
            jumpToFailUrl (type) {
                if (type === 'import') {
                    window.location.href = this.failImportUrl
                    this.isImportErrorShow = false
                } else if (type === 'export') {
                    window.location.href = this.failExportUrl
                    this.isExportErrorShow = false
                }
            },
        },
        filters:{
            auditStatus(data){
                switch (data) {
                    case 1:
                        return '待审核';
                    case 2:
                        return '审核通过'
                    case 3:
                        return '驳回'
                    default:
                        return '';
                    }
                }
            }
    }
</script>

<style lang="scss" scoped>
.content-sensitive {
    background: #ffffff;
    padding-right: 20px;
}
.content-sensitive-btn {
    padding-bottom: 20px;
}
</style>